export const tpaPreviewDataFunctionLibrary = {
    getTpaCompsPreviewData: tpaCompsPreviewData => tpaCompsPreviewData
}
